import { Inject } from "inversify-props"
import type { VendaServiceAdapter } from "../venda/adapter/VendaServiceAdapter"
import { FindModalidadeDeVendaUseCase } from "../venda/FindModalidadeDeVendaUseCase"
import { Carrinho } from "@/models/venda/Carrinho"
import { criarEmissaoDeNota, criarVendaDoPdv } from "@/shareds/venda-shareds"
import { ItemDaVenda, Pagamento, TurnoDeVenda, Venda } from "@/models"
import type { ClienteServiceAdapter } from "../cliente/adapter/ClienteServiceAdapter"
import UserLoginStore from "@/store/vuex/authentication/UserLoginStore"

export class ImportarCarrinhoUseCase {
	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	@Inject('ClienteServiceAdapter')
	private clienteService!: ClienteServiceAdapter

	private findModalidadeDeVendaUseCase = new FindModalidadeDeVendaUseCase()

	async importarCarrinho(
		carrinho: Carrinho,
		turnoDeVenda: TurnoDeVenda | null,
	): Promise<Venda> {
		console.log("carrinho", carrinho)
		if (!carrinho) {
			throw new Error("Carrinho não informado para importação")
		}

		if (!carrinho.loja) {
			throw new Error("Carrinho sem loja associada")
		}

		if (!carrinho.vendedor) {
			throw new Error("Carrinho sem vendedor associado")
		}

		const loja = carrinho.loja
		let novaVenda: Venda

		if (turnoDeVenda != null) {
			novaVenda = criarVendaDoPdv(turnoDeVenda.pontoDeVenda)
		} else {
			novaVenda = criarEmissaoDeNota()
		}

		if (carrinho.cliente && carrinho.cliente.cnpjOuCpf) {
			const cliente = await this.clienteService.get(carrinho.cliente.cnpjOuCpf)
			novaVenda.cliente = cliente
			novaVenda.cpfDoCliente = carrinho.cliente.cnpjOuCpf
		}

		const tipoDePagamento = loja.tiposDePagamento.find(tipo => tipo.formaDePagamento === 'Demonstração')
		if (!tipoDePagamento) {
			throw new Error("Não foi encontrado forma de pagamento 'Demonstração' para esta loja, verificar cadastro.")
		}

		const pagamentoDemonstracao: Pagamento = {
			id: '',
			valor: carrinho.valorTotal,
			tipoDePagamento: tipoDePagamento,
			dataHoraPagamento: new Date(),
			qtdeDeParcelas: 0,
			status: 'Pago',
			valorDaTaxa: 0,
			detalhesDoPagamentoId: null,
			link: null,
			valePresenteId: null,
			linkIdAsaas: null,
			parcelasCrediario: null,
			detalhesPagamentoEmChequeId: null,
			devolucaoValePresenteId: null,
		}

		novaVenda.pagamentos = [pagamentoDemonstracao]
		novaVenda.loja = loja.id
		novaVenda.cuponsDeDesconto = []
		novaVenda.tipoDeTransacao = 'Venda'
		novaVenda.isBrinde = false
		novaVenda.isConsignado = false
		novaVenda.isDemonstracao = true
		novaVenda.vendedor = [carrinho.vendedor]
		novaVenda.tipoNota = 'Saída'
		novaVenda.carrinhoId = carrinho.id

		novaVenda.itens = carrinho.itens.map<ItemDaVenda>(item => ({
			id: '',
			desconto: {
				isPercentual: false,
				valor: 0,
			},
			quantidade: item.quantidade,
			quantidadeLida: 0,
			preco: item.preco,
			precoDeCusto: 0,
			produto: item.produto,
			idConjunto: null,
			descontoVarejo: 0,
			percentualCashback: 0,
			diasParaEfetivarCashback: 0,
			isBrinde: false,
			idItemNotaOrigem: null,
			chaveNotaOrigem: null,
			diasParaExpirarCashback: 0,
			possuiDescontoPorTabela: false,
			valorDescontoRateadoDoItem: 0,
			itemDeDevolucao: false,
			isTotalmenteTrocado: false,
			motivoCancelamento: null,
			isCompra: false,
			idItemOrigem: '',
			isDaVendaReaberta: false,
			vendedor: carrinho.vendedor,
			autenticadoParaLiberarProdutoSemEstoque: false,
			vendaOrigemDoItem: null,
			valorFreteRateado: 0,
			isItemReferenteATroca: false,
			isDeOutraLoja: false,
			percentualDescontoTabelaPreco: 0,
			precoDeCustoReal: 0,
			usuarioIdLiberacaoVendaSemEstoque: '',
			skuPai: null,
		}))

		const params = {
			isDevolucao: false,
			isDemonstracao: true,
			isVenda: false,
		}

		const modalidade = await this.findModalidadeDeVendaUseCase.findModalidadePadrao(loja.id, params)
		novaVenda.modalidadeDeVenda = (modalidade && modalidade.modalidade !== '') ? modalidade : null

		novaVenda.autenticandoParaLiberarVendaSemEstoque = UserLoginStore.autenticandoParaLiberarVendaSemEstoque

		return novaVenda
	}
}
